import Typography, { type TypographyProps } from "@mui/material/Typography";

interface SectionLabelProps extends TypographyProps {
  /** Remove default margin — use when the label sits inside a layout that already controls spacing. */
  noGutter?: boolean;
}

/** Small eyebrow label that titles a page section. Renders as a semantic `<h2>`. */
export function SectionLabel({ noGutter, style, ...props }: SectionLabelProps) {
  return (
    <Typography
      variant="overline"
      component="h2"
      color="text.secondary"
      style={noGutter ? { margin: 0, ...style } : style}
      {...props}
    />
  );
}
